import { isArray } from 'lodash-es';
import { mergeDeep } from './mergeDeep';

/**
 *
 * @param arrayOfObjects array of object
 * @return merged object of all the members of arrayOfObjects
 */
export function mergeAllObjects(arrayOfObjects: any[]) {
    if (isArray(arrayOfObjects)) {
        let merged = {};
        arrayOfObjects.filter(obj => typeof obj === 'object').forEach(obj => (merged = mergeDeep(merged, obj)));
        return merged;
    } else {
        return arrayOfObjects;
    }
}
